import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { PdfEditorComponent, TPdfControl, TPdfForm } from "src/app/shared/components/pdf-editor/pdf-editor.component";
import { TableConfig } from "src/app/shared/components/phoenix-table/phoenix-table.interface";

interface IPlaygroundData {
  id: number,
  fName: string;
  lName: string;
  email: string;
  address: string;
  date?: Date;
  status: string;
}

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class playgroundComponent implements OnInit {
  @ViewChild(PdfEditorComponent) pdfEditor: PdfEditorComponent;

  private _fb = inject(FormBuilder);
  private cdr = inject(ChangeDetectorRef);

  tableConfig: TableConfig<IPlaygroundData> = {
    columns: [
      { key: 'id', title: 'ID', sortable: true },
      { key: 'fName', title: 'First', sortable: true },
      { key: 'lName', title: 'Last', sortable: true },
      { key: 'email', title: 'Email', sortable: false },
      { key: 'address', title: 'Address', sortable: false },
      { key: 'date', title: 'Date', sortable: true },
      // { key: 'date1', title: 'Date1', sortable: true },
      // { key: 'date2', title: 'Date2', sortable: true },
      { key: 'status', title: 'Status', sortable: true },
      {
        key: 'actions',
        title: 'Actions',
        type: 'actions',
        action: {
          text: 'View',
          callback: () => console.log(' View works'),
          ariaLabel: () => `Hello's From Here's`
        }
      }
    ],
    hasActions: true,
    selectionMode: 'checkbox',
    trackBy: (index: number, item: IPlaygroundData) => item.id,
    containerHeight: 500,
    defaultColumnSort: 'lName',
    defaultSortOrder: 'asc'
  };

  tableData: IPlaygroundData[] = (() => {
    const arr = [];

    for (let i = 1; i <= 100000; i++) {
      arr.push({
        id: i,
        fName: ['Alice', 'Bob', 'Charlie', 'Zara', 'Roy', 'Steven', 'Sandra', 'Sean', 'Megan'][Math.floor(Math.random() * 9)],
        lName: ['Johnson', 'Smith', 'Brown', 'Garcia', 'Henry', 'Cole', 'Steele', 'Lewis', 'Williams'][Math.floor(Math.random() * 9)],
        email: ['alice.johnson@example.com', 'bob.smith@example.com', 'charlie.brown@example.com', 'zara.garcia@example.com', 'terri.gardner@example.com', 'david.luna@example.com', 'kristina.curtis@example.com', 'colin.moore@example.com', 'tina.haynes@example.com'][Math.floor(Math.random() * 9)],
        address: ['12341 Sesame place, Monroe NY 10021', '456 Elm Street, Springfield IL 62701', '789 Oak Avenue, Oakmont PA 15139', '789 Oak Avenue, Oakmont PA 15139', '701 Miller Walk, New Sydney, MN 91584', '773 Moyer Ferry Apt. 059, Mayertown, NC 96080', '9304 Kelly Fields, Whiteview, MD 30802', '66612 Smith Islands Suite 698, Smithland, MA 54822', '0739 Thompson Lock Suite 145, Lake Matthewfort, TX 41418'][Math.floor(Math.random() * 9)],
        date: ['01/25/2023', '12/14/2021', '04/04/2024', '09/01/2023', '06/05/2022'][Math.floor(Math.random() * 5)],
        status: ['Active', 'Inactive'][Math.floor(Math.random() * 2)]
      });
    }

    return arr;
  })();

  ngOnInit(): void {
    setTimeout(() => {
      // simulate getting data and setting pdf fields from api
      this.pdfForm.controls.vendorName.patchValue({ userValue: 'jesse pinkman' });
      this.pdfForm.controls.phone.patchValue({ userValue: '999-999-9999' });
      this.pdfForm.controls.fax.patchValue({ userValue: '888-888-8888' });
      this.pdfForm.controls.physicianName.patchValue({ userValue: 'walter white' });
      this.pdfForm.controls.address.patchValue({ userValue: '987 second rd' });

      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }, 5000);
  }

  readonly pdfForm = this._fb.group<TPdfForm>({
    vendorName: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 101'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    phone: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 102'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    fax: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 103'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    physicianName: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 104'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    address: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 105'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    officeContact: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 106'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    officePhone: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 107'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    officePhoneExt: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1033'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    providerNpi: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1024'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    providerTaxId: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1026'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    patientFirstName: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 109'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    patientLastName: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1011'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    dateOfBirth: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1010'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    insuranceIdNumber: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1012'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    diagnoses: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1013'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    icd10Codes: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1014'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    durationOfTherapy: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Radio Button 1'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    durationOfTherapyOther: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1029'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    routeOfAdministration: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Radio Button 2'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    dateOfLastOfficeVisit: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1030'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    currentHeight: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1016'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    currentWeight: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1017'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    currentBmi: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1027'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    pediatricHeight: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1031'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    pediatricWeight: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1032'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    nutritionalProduct: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1020'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    clinicalIndication: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1021'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    soleSourceOfNutrition: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Radio Button 3'),
      type: this._fb.control('yes/no'),
      userValue: this._fb.control('')
    }),
    dailyVolume: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1022'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    triedGrocery: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Radio Button 4'),
      type: this._fb.control('yes/no'),
      userValue: this._fb.control('')
    }),
    triedGroceryDescription: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1023'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
    signedDate: this._fb.group<TPdfControl>({
      pdfField: this._fb.control('Text Field 1025'),
      type: this._fb.control('text'),
      userValue: this._fb.control('')
    }),
  });
}
